/**
 * @description
 * Where {@link DateValidator.compare} publishes its error.
 *
 * A cross-field rule has to live on the `FormGroup` (only the group can see both sides), but the
 * message usually belongs next to a single field. This enum decouples the two: the rule stays
 * group-level, the error lands wherever the UI needs it.
 */
export enum CompareErrorTarget {

    /**
     * @description Default — the error is returned to the group, so `formGroup.errors` carries it
     */
    Group = 'group',

    /**
     * @description The error is written on the start control, so its own form-field renders it
     */
    Start = 'start',

    /**
     * @description The error is written on the end control, so its own form-field renders it
     */
    End = 'end',

    /**
     * @description The error is written on **both** sibling controls, marking the whole range
     */
    Both = 'both',
}

/**
 * @description Union type for compare error target string literals
 */
export type CompareErrorTargetType = 'group' | 'start' | 'end' | 'both';

/**
 * @description Union type for compare error target that accepts both enum values and string literals
 */
export type ICompareErrorTarget = CompareErrorTarget | CompareErrorTargetType;
